// extracted by mini-css-extract-plugin
module.exports = {"root":"CancelationPolicyInfo_root__2rwIJ","heading":"CancelationPolicyInfo_heading__1jQuG","cancelationPolicy":"CancelationPolicyInfo_cancelationPolicy__eekpW"};